export const BASE_URL = import.meta.env.VITE_API_URL || 'https://api.carfile.app/'
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || 'auth.carfile.app'
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || 'YOUR_ADMIN_SPA_CLIENT_ID'
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.carfile.app'
export const AUTH0_REDIRECT_URI = window.location.origin
